import React from 'react';
import PropTypes from 'prop-types';
import ModalCustomField from './sub_components/modalCustomField';
import ModalStandardFields from './sub_components/modalStandardFields';

export default function ModalFields({
    formEntries,
    showModal = false,
    standardFields = [],
    customTypes = [],
    defaultForm = {},
    onAddStandardFields = () => {},
    onAddCustomField = () => {},
    onToggleModal = () => {},
    usage = null,
    defaultLanguage,
    languageOptions
}) {
    const [showModalCustom, setShowModalCustom] = React.useState(false);
    const [formEntriesStandard, setFormEntriesStandard] = React.useState(formEntries);

    return (
        <>
            <ModalStandardFields
                standardFields={standardFields}
                defaultForm={defaultForm}
                formEntriesStandard={formEntriesStandard}
                onChangeFormEntries={setFormEntriesStandard}
                showModal={showModal && !showModalCustom}
                onAddStandardFields={onAddStandardFields}
                onClose={() => onToggleModal(false)}
                switchModal={() => setShowModalCustom(true)}
                usage={usage}
            />
            <ModalCustomField
                field={null}
                customTypes={customTypes}
                showModal={showModalCustom}
                onAddField={onAddCustomField}
                onClose={() => setShowModalCustom(false)}
                usage={usage}
                defaultLanguage={defaultLanguage}
                languageOptions={languageOptions}
                onCloseAllModals={() => {
                    setShowModalCustom(false);
                    onToggleModal(false);
                }}
            />
        </>
    );
}

ModalFields.propTypes = {
    formEntries: PropTypes.array.isRequired,
    standardFields: PropTypes.array,
    customTypes: PropTypes.array,
    defaultForm: PropTypes.object,
    showModal: PropTypes.bool,
    onToggleModal: PropTypes.func,
    onAddStandardFields: PropTypes.func,
    onAddCustomField: PropTypes.func,
    usage: PropTypes.string
};
